module.exports = __webpack_public_path__ + "img/ie.b09988a2.svg";